import React from 'react';

const PageNotFound = () => (
  <div
    className="py-5"
    style={{ backgroundColor: '#e1dff3' }}
  >
    <div
      className="m-auto mw-100"
      style={{ width: '700px' }}
    >
      <img src="/assets/img/404-in.png" className="mw-100" />
    </div>
  </div>
);

export default PageNotFound;
